// extracted by css-extract-rspack-plugin
export default {"container":"container-lD1Bum","noTitle":"noTitle-sZrWwv"};